import React, {PureComponent} from "react"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import {perkbox} from "@irati/ui/src/global/colors"
import {RouterLink} from "@irati/ui/src/Link"
import {TenantOnboardingStepStates} from "@irati/types"
import tracking, {TenantSetupInterfaces} from "@irati-tracking/tenant-setup"
import {generateReadableStepNumber, isPathActive} from "../../helpers"
import {Step, SetupSteps} from "../../constants/stepConfig"
import {StepLinkContainer, StepNumberContainer, StepNumberLabel, StepLabel, MarginIcon} from "./styled"

interface Props extends InjectIntl, Step {
  title: string,
  stepNumber: number,
  state: string,
  nestedPath: string,
  stepId: SetupSteps
}

class StepLink extends PureComponent<Props> {
  handleClick = () => {
    const {stepId, formatMessage, ...step} = this.props
    const params: TenantSetupInterfaces.StepParams = {
      step_name: formatMessage({id: step.title}),
      step_id: stepId,
      step_number: step.order
    }
    tracking.navigateStep(params)
  }

  render() {
    const {title, stepNumber, state, nestedPath} = this.props

    const done = state === TenantOnboardingStepStates.Done
    const skipped = state === TenantOnboardingStepStates.Skipped

    return (
      <RouterLink styled={false} to={nestedPath} onClick={this.handleClick}>
        <StepLinkContainer active={isPathActive(nestedPath)}>
          <StepNumberContainer>
            <StepNumberLabel done={done} large flush>
              {generateReadableStepNumber(stepNumber)}
            </StepNumberLabel>
          </StepNumberContainer>
          <StepLabel done={done} flush>
            <FormattedMessage id={title} />
          </StepLabel>
          {done && <MarginIcon size={20} icon="tick" flush color={perkbox.blue} />}
          {skipped && <MarginIcon icon="circleHollow" color={perkbox.blue} />}
        </StepLinkContainer>
      </RouterLink>
    )
  }
}

export default injectIntl(StepLink)
